export default "__VITE_ASSET__cafe53f8__"